import { render, staticRenderFns } from "./SmsOperatorTariffZoneGroup.vue?vue&type=template&id=ed664332&"
import script from "./SmsOperatorTariffZoneGroup.vue?vue&type=script&lang=ts&"
export * from "./SmsOperatorTariffZoneGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports